module.exports = __webpack_public_path__ + "assets/slack.4d2bfe18.svg";